import * as Flowbite from 'flowbite';
import './theme-toggle.js';
import './modals.js';
import './tooltip.js';

window.Flowbite = Flowbite;